module.exports = __webpack_public_path__ + "static/media/dollar-sign.8b28831a.svg";